import Element from './element';
import { ISapElement } from './api/models/sapElement';
import { ElementsToSapElementsConverter } from './sap/elementsToSapElementsConverter';

class PriceManager {

    private elementsToSapElementsConverter = new ElementsToSapElementsConverter();

    public getPrice(sapElements: ISapElement[], elements: Element[]): number {
        const result = this.elementsToSapElementsConverter.convert(sapElements, elements);
        return this.getPriceFromSapElements(result);
    }

    public getPriceFromSapElements(sapElements: ISapElement[]): number {
        let sum = 0;
        sapElements.forEach((x) => sum += x.price);
        return sum;
    }
}

export const priceManager = new PriceManager();
